export const imgError = {
    bind: function (el, binding) {
        if (el.tagName == 'IMG') {             // 图片不存在时
            if (!String(el.src).trim().length) {
                el.src = binding.value
            } else {                             // 图片存在
				let url = el.src
                if (binding.value) el.src = binding.value
                // 预加载需要的图片
                let image = new Image()
                image.addEventListener('load', (event) => {
                    if (url !== binding.value) el.src = url
                })
                image.src = url
			}
            // 图片加载错误
            el.onerror = function () {
                if (binding.value) el.src = binding.value
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/utils/directives.js